import {
  DeclinedMessageCardFragment,
  MatchedVenueCardFragment,
} from '../../../../Components/Cards/VenueCards/VenueCards.generated'
import DeclinedVenues from './DeclinedVenues'
import MatchedVenues from './MatchedVenues'

interface MatchesAndDeclinesProps {
  matches: Array<MatchedVenueCardFragment | null>
  declines: Array<DeclinedMessageCardFragment | null>
}

const MatchesAndDeclines = ({
  matches,
  declines,
}: MatchesAndDeclinesProps): JSX.Element => {
  const compact = matches.length === 0 && declines.length === 0
  return (
    <>
      <MatchedVenues matches={matches} compact={compact} />
      <DeclinedVenues declines={declines} compact={compact} />
    </>
  )
}

export default MatchesAndDeclines
